<template lang="html">
  <textarea class="continuous-textarea" v-focus="!disabled && autofocus" :disabled="disabled" :placeholder="placeholder" :value="value" @blur="onBlur" @focus="onFocus" @input="onInput" @keydown.enter.prevent></textarea>
</template>

<script>
import focus from '@/directives/focus';

export default {
  data() {
    return {
      focussed: false,
    };
  },
  directives: {
    focus,
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.value.replace(/\n*/g, '').replace(/ {2,}/g, ' '));
    },
    onBlur() {
      this.focussed = false;
      this.$emit('blur');
    },
    onFocus() {
      this.focussed = true;
      this.$emit('focus');
    },
  },
  props: {
    autofocus: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Your thoughts',
    },
    value: String,
  },
};
</script>

<style lang="stylus" scoped>
.continuous-textarea
  cursor: text
  position: relative
  box-sizing: content-box
  max-height: 100%
  margin: 0
  padding: 1px 0 // fix scrollbars appearing
  outline: 0
  border: 0
  font-family: inherit
  font-size: inherit
  font-weight: 600
  color: inherit
  background-color: transparent
  resize: none
  white-space: pre-wrap
  word-wrap: break-word
  line-height: 1.35
  width: 100%
  height: 100%
  resize: none

  &::placeholder
    color: alpha(#000, 0.38)
    text-transform: capitalize
    opacity: 1

  &:disabled
    opacity: 1
</style>
